import React from 'react';

   const Home = React.lazy(() => import('./Layoutt'));
   const Terms = React.lazy(() => import('./components/Terms'));
   const CardPage = React.lazy(() => import('./components/CardPage'));
   const FacePage = React.lazy(() => import('./components/FacePage'));
   const EnrollPage = React.lazy(() => import('./components/EnrollPage'));
   const NotFound =  React.lazy(() => import('./components/Page404'));

const routes = [
  { path:'/', exact: true, name: 'Home', component:<Home  /> },
  { path:'/tncs', name: 'Terms', component:<Terms /> },
  { path:'/card_page', name:'CardPage', component:<CardPage />},
  { path:'/face_page', name:'FacePage', component:<FacePage />},
  { path:'/enroll_page', name:'EnrollPage', component:<EnrollPage />}, 
  { path:'*', name:'404 Page', component:<NotFound />}, 
];

export default routes;